module.exports = __webpack_public_path__ + "img/stickers-RIB.3e9731de.jpg";